import React from 'react';
import { useCheckFormSchema } from '../hooks/use-check-form-schema.hook';
import { useFormFieldParams } from '../hooks/use-form-field-params.hook';

export const RadioField = ({ name, label, value, onChange }: RadioFieldProps) => {
  useCheckFormSchema({ name });

  const { inputProps, isReadonly } = useFormFieldParams({ name });

  return (
    <div className={'flex'}>
      <label className={'flex items-center gap-2'}>
        <input{...inputProps}
              type="radio"
              value={value}
              id={`input-${name}`}
              className={'form-field-input'}
              disabled={isReadonly ?? false}
              onChange={(ev) => onChange?.(ev.target.value)}
        />
        {label}
      </label>
    </div>
  );
};

export interface RadioFieldProps {
  name: string;
  label: string;
  value: any;
  onChange?: (value: any) => void;
}